import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const QuickStartGuide = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const steps = [
    {
      icon: 'MapPin',
      title: 'Add Locations',
      description: 'Enter starting addresses for all meeting participants'
    },
    {
      icon: 'Car',
      title: 'Choose Transport',
      description: 'Select how each person will travel (driving, walking, transit, bike)'
    },
    {
      icon: 'Calculator',
      title: 'Calculate',
      description: 'Find meeting points with equal travel time for everyone'
    },
    {
      icon: 'Filter',
      title: 'Refine',
      description: 'Filter results by location type (cafe, park, library, etc.)'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-border rounded-xl p-4 md:p-6">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between transition-smooth focus:outline-none focus:ring-2 focus:ring-ring rounded-lg"
      >
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
            <Icon name="Lightbulb" size={20} className="text-primary-foreground" />
          </div>
          <div className="text-left">
            <h3 className="font-heading font-semibold text-foreground">
              How It Works
            </h3>
            <p className="caption text-muted-foreground">
              Quick guide to finding your perfect meeting spot
            </p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          className="text-muted-foreground transition-smooth"
        />
      </button>
      {isExpanded && (
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps?.map((step, index) => (
            <div 
              key={index}
              className="flex flex-col items-start gap-3 p-4 bg-background rounded-lg transition-smooth hover:shadow-md"
            >
              <div className="flex items-center gap-3 w-full">
                <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg flex-shrink-0">
                  <Icon name={step?.icon} size={16} className="text-primary" />
                </div>
                <span className="font-heading text-2xl font-bold text-primary/20">
                  {index + 1}
                </span>
              </div>
              <div>
                <h4 className="font-heading font-semibold text-foreground mb-1">
                  {step?.title}
                </h4>
                <p className="caption text-muted-foreground">
                  {step?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuickStartGuide;